f
<template>
  <v-row>
    <v-col>
      <v-col class="d-flex justify-space-between mx-auto flex-wrap container">
        <ToolbarTitles :title="title" />
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard" class="container">
        <CardsView
          :items="accounts"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
          :showInicializeCC="true"
        />
      </div>
      <div v-if="!showCard" class="container">
        <TableWithSearch
          :items="accounts"
          :headers="allHeaders"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
          :showInicializeCC="true"
        />
      </div>
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset()"
        @keydown.enter="triggerSubmit"
      >
        <FormOrder
          :allFields="parameters.items"
          @save="saveForm"
          @cancel="reset"
          :mode="mode"
          ref="formOrder"
        />
      </v-dialog>
      <v-dialog
        v-model="showInicializeCC"
        max-width="500px"
        persistent
        @keydown.esc="reset()"
        @keydown.enter="triggerSubmit"
      >
        <FormInitialize @cancel="reset" :mode="mode" :accountId="accountId" />
      </v-dialog>
      <my-Dialog
        @closeEditDialog="closeEditDialog"
        :dialog="showModelRelation"
      ></my-Dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
      <Snackbar
        :alert="showSnackbar"
        :textAlert="textSnackbar"
        :color="colorSnackbar"
      />
    </v-col>
  </v-row>
</template>
<script>
import currentAccounts from "@/store/currentAccounts/currentAccounts.js";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import FormOrder from "@/components/Complement/FormOrder.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import CardsView from "@/components/Complement/CardsView.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import MyDialog from "./relations/relationDialog.vue";
import FormInitialize from "./commons/FormInitialize.vue";

export default {
  name: "Reports",
  components: {
    ToolbarTitles,
    TableWithSearch,
    FormOrder,
    Snackbar,
    ButtonsCardList,
    CardsView,
    DeleteDialog,
    MyDialog,
    FormInitialize,
  },
  data() {
    return {
      titleTable: this.$tc("nav.currentAccounts"),
      title: this.$tc("nav.currentAccounts"),
      mode: "",
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Descripción",
          value: "description",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Unidad",
          value: "unit",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      open: false,
      showSnackbar: false,
      textSnackbar: "",
      colorSnackbar: "",
      showCard: true,
      unitType: [
        {
          text: "Dias",
          value: "D",
        },
        {
          text: "Horas",
          value: "H",
        },
      ],
      itemOld: {},
      titleDelete: this.$tc("CurrentAccounts.deleteCurrentAccounts"),
      itemToDelete: null,
      showModelRelation: false,
      showInicializeCC: false,
      accountId: null,
    };
  },
  mounted() {
    currentAccounts.dispatch("getAccounts");
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },
  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    accounts() {
      return currentAccounts.state.accounts
        ? currentAccounts.state.accounts
        : [];
    },
    parameters() {
      return {
        items: [
          {
            id: 1,
            show: true,
            data: "",
            name: "nombre",
            type: "text",
            label: this.$tc("CurrentAccounts.nameLabel"),
            items: [],
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 1,
          },
          {
            id: 2,
            show: true,
            data: "",
            name: "descripcion",
            type: "text",
            label: this.$tc("CurrentAccounts.descLabel"),
            items: [],
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 2,
          },
          {
            id: 3,
            show: true,
            data: "",
            name: "unidad",
            type: "select",
            label: this.$tc("CurrentAccounts.TypeLabel"),
            items: this.unitType,
            itemText: "text",
            itemValue: "value",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 3,
          },
        ],
      };
    },
    openDelete: {
      get() {
        return currentAccounts.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openRelation: {
      get() {
        return currentAccounts.state.openRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    triggerSubmit() {
      if (this.$refs.formOrder) {
        this.$refs.formOrder.submitForm();
      }
    },

    openEditDialog() {
      this.$forceUpdate();
      this.showModelRelation = true;
    },

    closeEditDialog() {
      this.showModelRelation = false;
      configTable.commit("setColums", []);
      let nameTable = this.titleTable;
      configTable
        .dispatch("getColumsTableName", nameTable)
        .then(() => {
          if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
            this.saveConfigColumns();
          }
        })
        .catch((error) => {
          console.error("Error occurred:", error);
        });
    },

    cardView(value) {
      this.showCard = value;
    },

    async refreshItems() {
      await currentAccounts.dispatch("getAccounts");
    },

    openDialog(type, item) {
      switch (type) {
        case "add":
          this.open = true;
          this.mode = this.$tc("CurrentAccounts.addCurrentAccounts");
          break;
        case "edit":
          currentAccounts.commit("setEdit", item);
          currentAccounts.dispatch("getAccountId", item.accountId);
          currentAccounts.commit("setOpenRelation", true);
          this.openEditDialog();
          break;
        case "delete":
          this.open = false;
          currentAccounts.commit("setOpenDelete", true);
          this.itemToDelete = item.accountId;
          break;
        case "inicializeCC":
          this.accountId = item.accountId;
          this.open = false;
          this.showInicializeCC = true;
          this.mode = this.$tc("CurrentAccounts.initializeMassive");
          break;
        default:
          break;
      }
    },

    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },

    saveConfigColumns() {
      let columnsToSave = this.allHeaders;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    saveForm(item) {
      if (this.mode == this.$tc("CurrentAccounts.addCurrentAccounts")) {
        currentAccounts.commit("setNew", item);
        currentAccounts
          .dispatch("add")
          .then(() => {
            this.alert(
              this.$tc("CurrentAccounts.addCurrentAccountSuccess"),
              "primary",
              true
            );
          })
          .catch((e) => {
            this.showAlert(e.response.data.error.message, "#ff8d58");
          });
      }
      this.reset();
    },

    reset() {
      this.showInicializeCC = false;
      this.open = false;
      this.parameters.items[0].data = "";
      this.parameters.items[1].data = "";
      this.parameters.items[2].data = "";
    },

    alert(text, color, alert) {
      this.showSnackbar = alert;
      this.textSnackbar = text;
      this.colorSnackbar = color;
      setTimeout(() => {
        this.showSnackbar = false;
      }, 3000);
    },

    deleteItem() {
      currentAccounts.commit("setItemDelete", this.itemToDelete);
      currentAccounts
        .dispatch("delete")
        .then(() => {
          currentAccounts.commit("setOpenDelete", false);
          this.alert = true;
          this.textAlert = this.$tc(
            "CurrentAccounts.deleteCurrentAccountsAlert"
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
    },

    cancelDelete() {
      currentAccounts.commit("setOpenDelete", false);
    },
  },
};
</script>
<style scoped>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
